import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatListNumberedSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatListNumberedSVG;
